/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import {firestoreAction} from 'vuexfire';
import {db} from '@/firebaseConfig'

const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({commit}, width) {
    commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
  },

  // VxAutoSuggest
  updateStarredPage({commit}, payload) {
    commit('UPDATE_STARRED_PAGE', payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_LIMITED', list)
  },
  arrangeStarredPagesMore({commit}, list) {
    commit('ARRANGE_STARRED_PAGES_MORE', list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({commit}) {
    commit('TOGGLE_CONTENT_OVERLAY')
  },
  updateTheme({commit}, val) {
    commit('UPDATE_THEME', val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({commit}, payload) {
    commit('UPDATE_USER_INFO', payload)
  },

  addAddressUserInfo({commit}, payload) {
    commit('ADD_ADDRESS_USER_INFO', payload)
  },

  // ////////////////////////////////////////////
  // Cloud FireStore actions
  // ////////////////////////////////////////////

  bindParameters: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('parameters', db.collection('parameters'));
  }),

  bindSliderProducts: firestoreAction(({ bindFirestoreRef }) => {
    // return bindFirestoreRef('sliderProducts', db.collection('home').doc('sliderProducts'));
    return bindFirestoreRef('sliderProducts', db.collection('home').doc('sliderProducts'));
  }),

  bindSliderCategories: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('sliderCategories', db.collection('home').doc('sliderCategories'));
  }),

  bindBlog: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('blog', db.collection('home').doc('blog'));
  }),

  /*
    bindSliderProducts: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('sliderProducts', db.collection('sliderProducts'));
    }),
  */

  bindShowcaseProducts: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('showcaseProducts', db.collection('home').doc('showcaseTest'));
  }),

  bindPromotions: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('promotions', db.collection('home').doc('promotions'));
  }),

  bindSeasonal: firestoreAction(({bindFirestoreRef}) => {
    return bindFirestoreRef('seasonal', db.collection('parameters').doc('seasonal'));
  }),

  /*
      bindShowcaseProducts: firestoreAction(({ bindFirestoreRef }) => {
        return bindFirestoreRef('showcaseProducts', db.collection('showcaseProducts'));
      }),
    */

  bindPriceRanges: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('priceRanges', db.collection('filters').doc('priceRanges'));
  }),

/*
  bindPriceRanges: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('priceRanges', db.collection('priceRanges'));
  }),
*/

  bindVersions: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('versions', db.collection('filters').doc('versions'));
  }),

  /*
  bindVersions: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('versions', db.collection('versions'));
  }),
*/

  bindCategories: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('categories', db.collection('catalogs').doc('categories'));
  }),

  /*
    bindCategories: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('categories', db.collection('categories'));
    }),
  */

  bindProducts: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('products', db.collection('catalogs').doc('products'));
  }),

  bindDonationEvents: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('donationEvents', db.collection('catalogs').doc('donationEvents'));
  }),

  /*
    bindProducts: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('products', db.collection('products').where("status", "==", "ACT").orderBy('name'));
    }),
  */

  bindStates: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('states', db.collection('states').orderBy('name')).then(() => {}, () => {});
  }),

  bindCities: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('cities', db.collection('cities').orderBy('name')).then(() => {}, () => {});
  }),

  bindUser: firestoreAction(({ bindFirestoreRef }) => {
    return bindFirestoreRef('user', db.collection('user')).then(() => {}, () => {});
  }),

  bindOrders: firestoreAction(({ bindFirestoreRef }, email) => {
    return bindFirestoreRef('orders', db.collection('orders').where("user", "==", email).orderBy('date', 'desc'));
  }),

  // ////////////////////////////////////////////
  // SBG COMMON DATA
  // ////////////////////////////////////////////

  updateParameters({commit}, list) {
    commit('UPDATE_PARAMETERS', list);
  },

  updateSliderProducts({commit}, list) {
    commit('UPDATE_SLIDER_PRODUCTS', list);
  },

  updateShowcaseProducts({commit}, list) {
    commit('UPDATE_SHOWCASE_PRODUCTS', list);
  },

  updatePriceRanges({commit}, list) {
    commit('UPDATE_PRICE_RANGES', list);
  },

  updateVersions({commit}, list) {
    commit('UPDATE_VERSIONS', list);
  },

  updateCategoriesList({commit}, list) {
    commit('UPDATE_CATEGORIES_LIST', list);
  },

  updateHomeScreen({commit}, value) {
    commit('UPDATE_HOME_SCREEN', value);
  },

  updatePriceRange({commit}, item) {
    commit('UPDATE_PRICE_RANGE', item);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateVersion({commit}, item) {
    commit('UPDATE_VERSION', item);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateSelectedCategory({commit}, item) {
    commit('UPDATE_SELECTED_CATEGORY', item);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateProductSearch({commit}, phrase) {
    commit('UPDATE_PRODUCT_SEARCH', phrase);
    commit('UPDATE_HOME_SCREEN', 2);
  },

  updateProductsList({commit}, list) {
    commit('UPDATE_PRODUCTS_LIST', list);
  },

  updateProductImage({commit}, payload) {
    commit('UPDATE_PRODUCTS_IMAGE', payload);
  }

}

export default actions
